module.exports = __webpack_public_path__ + "assets/img/btn-view-696de0d0.png";